module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, [_c('v-list', [_c('v-list-tile', {
    staticClass: "last24-title"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("EVENTOS DE LAS ULTIMAS 24 HS")])], 1), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "last24-action"
  }, [_vm._v(_vm._s(_vm.allEvents.length === [] ? 0 : _vm.timeSeriesData.length))])], 1), _vm._v(" "), (_vm.allEvents.length !== 0) ? _c('div', _vm._l((_vm.timeSeriesData), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      staticStyle: {
        "content-visibility": "auto"
      },
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-avatar', [(item.type == 2) ? _c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('rect', {
      attrs: {
        "y": "10",
        "x": "4",
        "fill": item.color
      }
    })]) : _c('v-icon', {
      attrs: {
        "small": "",
        "color": item.color
      }
    }, [_vm._v("trip_origin")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('strong', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('v-list-tile-sub-title')], 1), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "last24-title"
    }, [_vm._v("\n          " + _vm._s(item.description) + " - " + _vm._s(item.time) + "\n        ")])], 1)
  }), 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6714de4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Events.vue
// module id = 776
// module chunks = 2